{
    window.addEventListener('load', function () {
        const mokuji = document.getElementById('mokuji');
        console.log(mokuji)
        if (!mokuji) {
            return;
        }
        // 元のh2とh3を全部取得
        let ids = [];
        let count = 1;
        const array = document.querySelectorAll('h2,h3');
        
        for (let i = 0; i < array.length; i++) {
            let e = array[i]
            e.id = 'mokuji' + count;
            ids.push(e);
            count++;
        }
        console.log(ids);

        ids.map(function (id) {
            let tag = id.tagName;
            let text = id.textContent;
            console.log(text);
            if (tag == 'H2') {
                mokuji.appendChild(createH2(id, text));
            } else if (tag == 'H3') {
                mokuji.appendChild(createH3(id, text));
            }
        });

        // 目次の１行分基本形を作る
        function createRow(id, text) {
            let li = document.createElement('li');
            let a = document.createElement('a');
            a.innerHTML = text;
            a.setAttribute('href', '#' + id.id);
            li.appendChild(a);
            return li;
        }


        function createH2(id, text) {
            let li = document.createElement('li');
            let a = document.createElement('a');
            a.innerHTML = '■' + text;
            a.setAttribute('href', '#' + id.id);
            li.appendChild(a);
            return li;
        }

        function createH3(id, text) {
            let li = document.createElement('li');
            let a = document.createElement('a');
            a.innerHTML = '-' + text;
            a.setAttribute('href', '#' + id.id);
            li.appendChild(a);
            li.className = "sub";
            return li;
        }
    });

}